module.exports = __webpack_public_path__ + "static/media/xara-logo.b0d7bd47.gif";


//////////////////
// WEBPACK FOOTER
// ./src/theme/assets/xara-logo.gif
// module id = 767
// module chunks = 0